import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import { toast } from "react-toastify";
import { sendMercureTest } from "services/api";
import { createMercureEventSource, getMercureHubUrl } from "services/apiMercure";

const MERCURE_TOPIC = "lider-admin-test";

export const MercureTestBlock = () => {
  const [messages, setMessages] = useState([]);
  const [subscribed, setSubscribed] = useState(false);
  const [sending, setSending] = useState(false);
  const eventSourceRef = useRef(null);

  const connect = useCallback(async () => {
    if (!getMercureHubUrl()) {
      toast.error("MERCURE_URL не настроен (baseUrl или REACT_APP_MERCURE_URL)");
      return;
    }

    if (eventSourceRef.current) {
      eventSourceRef.current.close();
    }
    const es = await createMercureEventSource(MERCURE_TOPIC);
    if (!es) {
      toast.error("Не удалось получить токен Mercure");
      return;
    }
    es.onmessage = (e) => {
      try {
        const data = JSON.parse(e.data);
        setMessages((prev) => [...prev.slice(-19), { ...data, receivedAt: new Date().toISOString() }]);
      } catch {
        setMessages((prev) => [...prev.slice(-19), { raw: e.data, receivedAt: new Date().toISOString() }]);
      }
    };
    es.onerror = () => {
      setSubscribed(false);
    };
    es.onopen = () => {
      setSubscribed(true);
    };
    eventSourceRef.current = es;
    toast.success("Подписка на Mercure активна");

  }, []);

  const disconnect = useCallback(() => {
    if (eventSourceRef.current) {
      eventSourceRef.current.close();
      eventSourceRef.current = null;
    }
    setSubscribed(false);
  }, []);

  useEffect(() => {
    return () => {
      if (eventSourceRef.current) {
        eventSourceRef.current.close();
      }
    };
  }, []);

  const handleSendTest = async () => {
    setSending(true);
    try {
      await sendMercureTest();
      toast.success("Тестовое сообщение отправлено");
    } catch (e) {
      toast.error(e.response?.data?.message || "Ошибка отправки");
    } finally {
      setSending(false);
    }
  };

  return (
    <Card className="mb-3">
      <CardBody>
        <h5 className="mb-2">Mercure — тест</h5>
        <p className="text-muted small mb-3">
          Подключитесь к Mercure и отправьте тестовое сообщение. Оно должно прийти всем открытым вкладкам.
        </p>
        <Row className="mb-3">
          <Col>
            {!subscribed ? (
              <Button color="primary" onClick={connect}>
                Подключиться к Mercure
              </Button>
            ) : (
              <Button color="warning" onClick={disconnect}>
                Отключиться
              </Button>
            )}
            <Button
              color="success"
              className="ml-2"
              onClick={handleSendTest}
              disabled={sending}
            >
              {sending ? "Отправка…" : "Отправить тест"}
            </Button>
          </Col>
        </Row>
        {subscribed && (
          <div className="small">
            <strong>Статус:</strong> подключено
          </div>
        )}
        {messages.length > 0 && (
          <div className="mt-3">
            <strong>Полученные сообщения:</strong>
            <ul className="list-unstyled mt-1 small">
              {messages.map((m, i) => (
                <li key={i} className="mb-1">
                  <code>{JSON.stringify(m)}</code>
                </li>
              ))}
            </ul>
          </div>
        )}
      </CardBody>
    </Card>
  );
};
